import React from "react";
import { usePermissionChecker } from "../..//hooks/UsePermissionsChecker";
import ThreeDotsLoader from "../loader/ThreeDotsLoader";

type RequiredPermission = {
  path: string;
  method: string;
  scope: string;
  model: string;
};

interface PermissionGuardProps {
  permissions: RequiredPermission[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  loadingFallback?: React.ReactNode;
  requireAll?: boolean;
  fallBackType?: "empty" | "unauthorized";
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permissions,
  children,
  fallback = null,
  loadingFallback = null,
  fallBackType = "empty",
  requireAll = false,
}) => {
  const { hasPermission, loading } = usePermissionChecker();

  if (loading) {
    return <ThreeDotsLoader />;
  }

  if (!hasPermission(permissions, requireAll)) {
    if (fallBackType === "empty") {
      return <></>;
    }
    return <div>Unauthorized</div>;
  }

  return <>{children}</>;
};
